import _get from 'lodash/get';
import { Department, Team } from 'graphql-common';
import {
  getAccessesValues,
  getEmptyAccessesValues,
} from '@lib/utils/accessesManagement';
import FieldNames from '@lib/enums/fieldNames/teamFieldNames';

export default function getTeamDefaultValuesFromQueryData(
  data: Team | undefined,
  membersIds: { id: string }[],
  linkedDepartments: Department[] = [],
) {
  return {
    [FieldNames.Name]: data?.name || '',
    [FieldNames.Description]: data?.description || '',
    [FieldNames.Accesses]: data?.accesses
      ? {
          ...getEmptyAccessesValues(),
          ...getAccessesValues(data.accesses),
        }
      : getEmptyAccessesValues(),
    [FieldNames.Color]: data?.color
      ? { value: _get(data, 'color', null) }
      : undefined,
    [FieldNames.Users]:
      membersIds?.length > 0
        ? membersIds.map(({ id }) => ({ value: id }))
        : null,
    [FieldNames.DepartmentLinks]: linkedDepartments?.length
      ? linkedDepartments.map(({ id, name, path, color }) => ({
          value: id,
          label: name,
          data: { path, color },
        }))
      : null,
    // Custom renders
    [FieldNames.DetailsTitle]: null,
    [FieldNames.MembersAssignationTitle]: null,
    [FieldNames.MembersAssignationMessage]: null,
    [FieldNames.TeamAccessesMessage]: null,
    [FieldNames.UsersList]: null,
    [FieldNames.TeamAccessRights]: null,
  };
}
